var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconMarketExplorer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-market-explorer-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,18V1H14V4H8V9H2v9H7.1a6.24,6.24,0,0,0,.78,1,5.93,5.93,0,0,0,7.72.58A1.47,1.47,0,0,0,16,20.75l2.06,2.05a1.45,1.45,0,0,0,1.06.44,1.48,1.48,0,0,0,1.06-.44,1.51,1.51,0,0,0,0-2.12l-2.06-2.06a1.48,1.48,0,0,0-1.22-.4c.05-.08.12-.14.17-.22ZM16,3h4V16H17.91a6,6,0,0,0-1.59-5.51c-.1-.1-.22-.17-.32-.26V3ZM14,6V9.08a6,6,0,0,0-4,.06V6ZM4,16V11H7.46a6,6,0,0,0-1.18,5Zm5.29,1.52a4,4,0,0,1,0-5.61,4,4,0,0,1,5.61,0,4,4,0,0,1-5.61,5.61Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconMarketExplorer);
export default __webpack_public_path__ + "static/media/navigation-icon-market-explorer.b58a38e4a4adc6156f67747ff2825c3c.svg";
export { ForwardRef as ReactComponent };